import { map, range, without } from 'lodash-es';

class FileHeadersCtrl {
  static bindings = {
    isFileSelected: '<',
    isLoading: '<',
    rowIndex: '<',
    headerRows: '<',
    mappedColumns: '<',
    error: '<',
    onRenderHeaders: '&',
    onRowIndexChange: '&',
    onHeaderRowChange: '&'
  };

  rowIndex;
  headerRows;
  mappedColumns;
  onRenderHeaders;
  onRowIndexChange;
  onHeaderRowChange;

  state;
  headers;

  rowIndexRange;

  constructor(private UploadModel, private $timeout) {
    'ngInject';
  }

  $onInit() {
    this.state = this.UploadModel.store.getState();

    this.$timeout(() => {
      this.onRenderHeaders();
    }, 0);
  }

  $onChanges(changes) {
    if (changes.rowIndex || changes.headerRows || changes.mappedColumns) {
      this.updateHeaders(this.rowIndex, this.mappedColumns);
    }
  }

  updateHeaders(rowIndex, mappedColumns) {
    if (rowIndex != null && this.headerRows != null) {
      this.rowIndexRange = range(0, this.headerRows.length);
      let headers = this.headerRows[rowIndex];
      let mappedHeaders = map(mappedColumns, 'headerName');
      headers = without(headers, ...mappedHeaders);
      this.headers = headers;
    }
  }

  updateHeaderRow(rowIndex) {
    this.updateHeaders(rowIndex, this.mappedColumns);
    this.onRowIndexChange({
      $event: {
        rowIndex: parseInt(rowIndex, 10)
      }
    });
    this.onHeaderRowChange({
      $event: {
        rowIndex
      }
    });
  }
}

export const FileHeadersComponent = {
  template: require('./fileHeaders.component.html'),
  controller: FileHeadersCtrl,
  bindings: FileHeadersCtrl.bindings
};
